import { SelectOption } from 'global';
import { DeclineReasonOption, SubmissionDeclineReasonCategory } from '../types';
import { translateStageCodes } from 'utils';
import { CreditSubmissionSelectOptionsResponse } from '../api/types';
import moment from 'moment/moment';

export const getSubmissionDeclineReasonsOptions = (creditSubmissionDeclineReasons: any[]): DeclineReasonOption[] => {
  return creditSubmissionDeclineReasons
    .filter(({ isActive }) => isActive)
    .map(csdr => ({ label: csdr.label, category: csdr.category, value: csdr.creditSubmissionDeclineReasonId }));
};

export const getAddEditDeclineReasonCategoryOptions = (): SelectOption[] => {
  return Object.keys(SubmissionDeclineReasonCategory).map(key => {
    return {
      label: SubmissionDeclineReasonCategory[key as keyof typeof SubmissionDeclineReasonCategory],
      value: SubmissionDeclineReasonCategory[key as keyof typeof SubmissionDeclineReasonCategory],
    };
  });
};

const sortCSByCreateDateTime = (cs: CreditSubmissionSelectOptionsResponse['creditSubmissionsSelectOptions'] = []) =>
  cs.toSorted((a, b) => moment(b.createdDateTime).valueOf() - moment(a.createdDateTime).valueOf());

export const getFundedSubmissionOptions = (
  creditSubmissionsOptions: CreditSubmissionSelectOptionsResponse['creditSubmissionsSelectOptions'] = []
): Array<SelectOption & { dynamicCSId: string }> => {
  const trustyCS = creditSubmissionsOptions.filter(Boolean);
  const sortedCS = sortCSByCreateDateTime(trustyCS);

  return sortedCS.map(cs => ({
    value: cs.value,
    dynamicCSId: cs.dynamicCSId,
    label: `${cs.lenderName}: ${translateStageCodes(cs.creditSubStage)}, ${cs.decision}`,
  }));
};
